import {createSelector} from '@reduxjs/toolkit';

import {adaptSortDataForRequest} from 'components/@common/widgets/custom-table/table-column-menu';
import {TAppState} from 'store/config/types';

import {TABLE_REPORT_SLICE} from '../table-report-slice-constants';

const rootSelector = (state: TAppState) => state[TABLE_REPORT_SLICE];

export const selectTableReportSortData = createSelector(
    createSelector(rootSelector, ({reportOptions}) => reportOptions),
    reportOptions => {
        const {sort} = reportOptions;
        return sort;
    },
);

export const selectTableReportSortDataAdaptedForRequest = createSelector(
    selectTableReportSortData, sort => adaptSortDataForRequest(sort),
);
